exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-features {\n  margin: 0 auto;\n  width: 90%;\n}\n.title.center {\n  margin-left: auto;\n  margin-right: auto;\n  text-align: center;\n}\n.feature-title {\n  text-transform: uppercase;\n  font-weight: 700;\n}\ndt {\n  text-transform: uppercase;\n  font-size: 0.95em;\n  letter-spacing: 0.01em;\n  margin-top: 0.5em;\n}\n.feature {\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 6em;\n}\n.box.feature {\n  text-align: center;\n  height: 13em;\n  margin-bottom: 2em;\n}\nimg {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.logo-test {\n  margin-bottom: auto;\n  width: auto;\n  height: 22em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-58227b76","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/Features.vue
// module id = 913
// module chunks = 1